(function($){

	var homeHeroSlider = function() {
		$('.hero-slider').slick({
			arrows: false,
			dots: false,
			fade: true,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false
		});
	};

	var heroVideo = function() {

		$('[data-action="hero-popup-play"]').on('click', function(e) {
			e.preventDefault();

			var heroVideoModal = document.getElementById('hero-video-modal');
			var heroVideoModalObj = $('#hero-video-modal');

			$.magnificPopup.open({
				mainClass: 'hero-popup',
				items: {
					src: '#hero-video-modal-container',
					type: 'inline',
				},
				callbacks: {
					open: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.play();
						}
					},
					close: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.pause();
							heroVideoModal.currentTime = 0;
						}
					},
				}
			}, 0);
			
		});
		
		$('[data-action="hero-popup-embed"]').magnificPopup({
			type: 'iframe',
			// mainClass: 'hero-popup'
		});

	};


	var scrollAnim = function(){

		var win = $(window);

		var items = $('.scroll-animate-item');

		var itemScrollCheck = function(){

			var winHeight = win.innerHeight();
			var winTop = win.scrollTop();
			var scrollTriggerPos = (winHeight * .8) + winTop;

			items.each(function(i, el){

				var item = $(el);
				var itemTop = item.offset().top;

				if(itemTop <= scrollTriggerPos){
					item.addClass('vis');
				}
				else{
					item.removeClass('vis');
				}

			});

		};

		itemScrollCheck();
		optimizedScroll.add(itemScrollCheck);
	};


	var scrollToAnchor = function(){

		if( location.hash ){
			// window.scrollTo(0,0);

			$( 'body' ).removeClass( 'nav-open' );
			
			var locationHashObj = $(location.hash);
			
			if(locationHashObj.length > 0){
				//$('body').removeClass('nav-open');
				// $('body,html').animate({
				// 	scrollTop: locationHashObj.offset().top - 150
				// }, 500);

				var waitTime = 501;

				if(!$('body').hasClass('scrolled')){
					waitTime = 501;
					$('body').addClass('scrolled');
				}

				setTimeout(function(){
					var anchorPosition = locationHashObj.offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
					$("html, body").animate({scrollTop: finalPosition}, 1000);


				}, waitTime);
			}
		}

		$('.scroll-to-anchor a, a[href^="#"]').on('click', function(e){

			if($(this).hasClass('no-scroll')){
				return;
			}
			else if(this.hash){
				
				var hashTarget = $(this.hash);

				if( hashTarget.length ){
					e.preventDefault();
					var waitTime = 0;
					
					if(!$('body').hasClass('scrolled')){
						waitTime = 501;
						$('body').addClass('scrolled');
					}

					setTimeout(function(){
						var anchorPosition = hashTarget.offset().top;
						var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
						$("html, body").animate({scrollTop: finalPosition}, 1000);

						$( 'body' ).removeClass( 'nav-open' );

					}, waitTime);
				}
			}
		});
	};

	var blockGallery = function() {
		$('.wp-block-gallery').magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		})
	};

	var testimonialsSlider = function() {
		//<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.96 40"><polygon points="11.87 40 4.66 20 11.96 0 7.44 0 0 20 7.44 40 11.87 40"/></svg>
		//<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.96 40"><polygon points=".09 0 7.3 20 0 40 4.52 40 11.96 20 4.52 0 .09 0"/></svg>
		$('.testimonials-slider').slick({
			arrows: true,
			prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.96 40"><polygon points="11.87 40 4.66 20 11.96 0 7.44 0 0 20 7.44 40 11.87 40"/></svg></button>',
			nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.96 40"><polygon points=".09 0 7.3 20 0 40 4.52 40 11.96 20 4.52 0 .09 0"/></svg></button>',
			dots: false,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false,
			// adaptiveHeight: true
		});
	};

	var videoPlay = function() {
		var video = document.getElementById('event-popup-video');

		$('[data-action="video-play"]').magnificPopup({
			type: 'inline',
			mainClass: 'event-video',
			callbacks: {
				 open: function() {
					video.play();
				},
				close: function() {
					video.pause();
					video.currentTime = 0;
				}	
			}
		});

		$('[data-action="video-embed-play"]').magnificPopup({
			type: 'iframe',
			mainClass: 'event-video'
		});
	};

	var faq = function() {
		$('[data-action="faq-open"]').on('click', function(e) {
			$(this).toggleClass('open');
		});
	};

	var tabs = function() {
		$('[data-action="tab-label"]').on('click', function(e) {
			e.preventDefault();

			var self = $(this);
			var targetId = this.hash;

			self.addClass('active');
			self.siblings('.tab-label').not(self).removeClass('active');

			$(targetId).addClass('active');
			$(targetId).siblings('.tab').not(targetId).removeClass('active');
		});
	};

	var tabSlider = function() {
		$('.tab-slider').slick({
			arrows: true,
			prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.96 40"><polygon points="11.87 40 4.66 20 11.96 0 7.44 0 0 20 7.44 40 11.87 40"/></svg></button>',
			nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.96 40"><polygon points=".09 0 7.3 20 0 40 4.52 40 11.96 20 4.52 0 .09 0"/></svg></button>',
			dots: true,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false,
			// adaptiveHeight: true
		});
	};

	var downloadGate = function() {
		// var gateForm = $('#download-gate-form');
		// var gateLinkInput = $('#input_4_4');

		$('[data-action="download-email-gate"]').on('click', function(e) {
			e.preventDefault();

			var popupId = this.hash;
			var linkUrl = $(this).data('url');
			var linkTitle = $(this).data('title');
			var linkType = $(this).data('type');

			// console.log(linkUrl);
			
			$.magnificPopup.open({
				mainClass: 'gate-form-popup',
				items: {
					src: popupId,
					type: 'inline',
				},
				callbacks: {
					open: function() {
						$('#input_4_6').val(linkUrl);
						$('#input_4_9').val(linkTitle);
						$('#input_4_10').val(linkType);
					},
					close: function() {
					}
				}
			});
		});

		$(document).on('click', '.gate-form-popup .gform_confirmation_message a[target="_blank"]', function(e) {
			e.stopPropagation();
			e.preventDefault();
			var fileurl = this.href;
			// console.log(this);
			window.open(fileurl);
			location.reload();
			return false;
		});

		$('.mpu-link-gate a').on('click', function(e) {
			e.preventDefault();

			// var popupId = this.hash;
			// var linkUrl = $(this).data('url');
			// var linkTitle = $(this).data('title');
			// var linkType = $(this).data('type');

			var linkUrl = this.href;
			
			$.magnificPopup.open({
				mainClass: 'gate-form-popup',
				items: {
					src: '#download-gate-form',
					type: 'inline',
				},
				callbacks: {
					open: function() {
						$('#input_4_6').val(linkUrl);
						// $('#input_4_9').val(linkTitle);
						// $('#input_4_10').val(linkType);
					},
					close: function() {
					}
				}
			});
		});
	};


	var paymentForm = function() {

		$('[data-action="accept-agreement"]').on('click', function(e) {
			e.preventDefault();

			var targetId = $(this).attr('href');

			$(targetId).addClass('vis');
			$(this).parents('.agreement').removeClass('vis');
		});
	
		$('[data-action="payment-form"]').magnificPopup({
			mainClass: 'payment-form-popup-wrap',
			type: 'inline',
			callbacks: {
				open: function() {
				},
				close: function() {
					$('.payment-form-popup .agreement').addClass('vis');
					$('.payment-form-popup .payment-form').removeClass('vis');
				}
			}
		});

	};

	var resources = function() {
		// $('[data-action="resource-video"]').magnificPopup({

		// });

		$('[data-action="resource-video-file"]').on('click', function(e) {
			e.preventDefault();

			var videoContainerId = this.hash;
			var videoId = $(this).attr('data-target');

			// console.log(targetId);

			var videoModal = document.getElementById(videoId);
			var videoModalObj = $(videoContainerId);

			$.magnificPopup.open({
				mainClass: 'hero-popup',
				items: {
					src: videoContainerId,
					type: 'inline',
				},
				callbacks: {
					open: function() {
						if(videoModalObj.length){
							videoModal.play();
						}
					},
					close: function() {
						if(videoModalObj.length){
							videoModal.pause();
							videoModal.currentTime = 0;
						}
					},
				}
			}, 0);
			
		});
		
		$('[data-action="resource-video-embed"]').magnificPopup({
			type: 'iframe',
		});
	};

	var loginForm = function() {
		$('[data-action="login-popup"]').magnificPopup({
			type: 'inline',
			mainClass: 'login-popup',
			 callbacks: {
				open: function() {
					$( 'body' ).removeClass( 'nav-open' );
					$('.nav-toggle').attr('aria-pressed', false);
				}
			}
		});
	};

	var crmFunction = function() {
		// var crmApiKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2NhdGlvbl9pZCI6InV5WUxmeWVVN3JyUVJGQjZrM1lBIiwiY29tcGFueV9pZCI6ImRWMzZNalUxNnp3VWtuZE1wbjlBIiwidmVyc2lvbiI6MSwiaWF0IjoxNjk1MTg3MzM3Mzk1LCJzdWIiOiJ1c2VyX2lkIn0.lJbhd66Vub4cF6jNhU31ia6w7iQhbz7CMAlGNjSiGfw';
	};

	var ebookPopup = function() {
		$('[data-action="ebook-popup"]').magnificPopup({
			type: 'inline',
			mainClass: 'ebook-popup-wrapper',
			 callbacks: {
				open: function() {
				}
			}
		});
	};


	Number.prototype.countDecimals = function () {

		if (Math.floor(this.valueOf()) === this.valueOf()){
			return 0;
		}

		var str = this.toString();
		if (str.indexOf(".") !== -1 && str.indexOf("-") !== -1) {
			return str.split("-")[1] || 0;
		}
		else if (str.indexOf(".") !== -1) {
			return str.split(".")[1].length || 0;
		}

		return str.split("-")[1] || 0;
	}

	var animateNumbers = function(){
		
		var win = $(window);

		var pr = new Intl.PluralRules('en-US', { type: 'ordinal' });

		var suffixes = new Map([
			['one',   'st'],
			['two',   'nd'],
			['few',   'rd'],
			['other', 'th'],
		]);

		var formatOrdinals = function(n){
			if(n > 0){
				var rule = pr.select(n);
				var suffix = suffixes.get(rule);
				// return `${n}${suffix}`;
				return suffix;
			}
			else{
				return '';
			}
		};


		function animateValue(obj, start, end, duration, ordinal) {

			if($(obj).attr('data-anim') == 'true'){
				$(obj).attr('data-anim', 'false');

				var endDecimals = end.countDecimals();

				let startTimestamp = null;
				const step = (timestamp) => {
					if (!startTimestamp){
						startTimestamp = timestamp;
					}
					const progress = Math.min((timestamp - startTimestamp) / duration, 1);
					// obj.innerHTML = Math.floor(progress * (end - start) + start);
					var numDecimals = progress * (end - start) + start;
					// var numFinal;
					
					if(end % 1 != 0){
						// obj.innerHTML = numDecimals.toFixed(endDecimals).toLocaleString();
						obj.innerHTML = numDecimals.toLocaleString(undefined, {minimumFractionDigits: endDecimals, maximumFractionDigits: endDecimals});
					}
					else{
						if(ordinal == 'true'){
							var baseNum = Math.floor(numDecimals).toLocaleString();
							var ordinalSuffix = formatOrdinals(baseNum);
							obj.innerHTML = baseNum + ordinalSuffix;
							// console.log(baseNum, ordinalSuffix);
						}
						else{
							obj.innerHTML = Math.floor(numDecimals).toLocaleString();
						}
					}
					if (progress < 1) {
						window.requestAnimationFrame(step);
					}
					else{
						// obj.innerHTML = 0;
						// $(obj).attr('data-anim', 'true');
						// console.log('done');
					}
				};
				window.requestAnimationFrame(step);
			}
		}

		$('.number-container').each(function(i,el){
			var elObj = $(el);
			var thisNum = elObj.attr('data-number');
			var thisPrepend = elObj.attr('data-prepend');
			var thisAppend = elObj.attr('data-append');
			var thisNumAnim = elObj.find('.number-anim');
			elObj.prepend('<span class="number-placeholder">' + '<span class="prepend">' + thisPrepend + '</span>' + thisNum + '<span class="append">' + thisAppend + '</span></span>');
			thisNumAnim.attr('data-anim', 'true');
			thisNumAnim.html(0);
		});

		var numbersAnim = function(){
			var winHeight = win.innerHeight();
			var winTop = win.scrollTop();
			var scrollTriggerPos = (winHeight * .7) + winTop;

			$('.number-anim').each(function(i,el){
				var numObj = $(el);
				var objTop = numObj.offset().top;
				var num = parseFloat($(el).attr('data-number'));
				// var doAnim = true;

				var ordinal = $(el).attr('data-ordinal');

				// if(ordinal == true){

				// 	var pr = new Intl.PluralRules('en-US', { type: 'ordinal' });

				// 	var suffixes = new Map([
				// 		['one',   'st'],
				// 		['two',   'nd'],
				// 		['few',   'rd'],
				// 		['other', 'th'],
				// 	]);

				// 	var formatOrdinals = function(n){
				// 		var rule = pr.select(n);
				// 		var suffix = suffixes.get(rule);
				// 		return `${n}${suffix}`;
				// 	};

				// 	formatOrdinals();
				// }

				// $(el).html(0);
				// if(isDone != true){
					if(objTop <= scrollTriggerPos){
						// console.log('scrn');
						// $(el).attr('data-anim', 'false');
						animateValue(el, 0, num, 2000, ordinal);
					}
					// else if(objTop >= (winTop + winHeight)){
						// console.log('scrn');
						// animateValue(el, num, 0, 100);
					// }
					else{
						// animateValue(el, num, 0, 100);
						// $(el).removeClass('anim');
						// doAnim = true;
						// $(el).html(0);
						// $(el).attr('data-anim', 'true');
					}
				// }
			});
		};

		numbersAnim();
		optimizedScroll.add(numbersAnim);
	};

	var hotseatHero = function() {
		if($('body').hasClass('page-template-page_hotseat')){
			var hero = $('.hero');
			var heroW = hero.outerWidth();
			var heroH = hero.outerHeight();
			var heroAspect = heroH / heroW;
			var heroVideo = $('.hero-video');

			function videoResize() {
				
				heroW = hero.outerWidth();
				heroH = hero.outerHeight();
				heroAspect = heroH / heroW;

				if(heroAspect > 0.5625){
					heroVideo.removeClass('tall');
					heroVideo.addClass('wide');
				}
				else{
					heroVideo.removeClass('wide');
					heroVideo.addClass('tall');
				}
				// console.log(heroAspect);
			}


			videoResize();
			optimizedResize.add(videoResize);
		}
	};

	var hotseatTestimonialsSlider = function() {
		$('.hotseat-testimonials-slider').slick({
			arrows: true,
			prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.96 40"><polygon points="11.87 40 4.66 20 11.96 0 7.44 0 0 20 7.44 40 11.87 40"/></svg></button>',
			nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.96 40"><polygon points=".09 0 7.3 20 0 40 4.52 40 11.96 20 4.52 0 .09 0"/></svg></button>',
			dots: true,
			speed: 1000,
			autoplay: false,
			autoplaySpeed: 4000,
			pauseOnHover: false,
			adaptiveHeight: true
		});

		$('[data-action="hotseat-slider-nav"]').on('click', function(e) {
			e.preventDefault();
			var targetSlide = $(this).data('target');
			$('.hotseat-testimonials-slider').slick('slickGoTo', targetSlide);
		});
	};


	var countdownTimer = function() {

		if($('.countdown-timer').length){

			// console.log('countdown');
		
			var timerContainer = $('.countdown-timer');
			var daysEl = timerContainer.find('.days').find('.number');
			var hoursEl = timerContainer.find('.hrs').find('.number');
			var minsEl = timerContainer.find('.mins').find('.number');
			var secsEl = timerContainer.find('.secs').find('.number');

			var endDate = timerContainer.attr('data-enddate');
			var targetTime = new Date(endDate);
			var _second = 1000;
			var _minute = _second * 60;
			var _hour = _minute * 60;
			var _day = _hour * 24;
			var timer;

			// console.log(targetTime);

			function showRemaining() {
		        var now = new Date();
		        var distance = targetTime - now;
		      
		        if (distance < 0) {
		            clearInterval(timer);
		            // document.getElementById('countdown').innerHTML = 'EXPIRED!';
		            return;
		        }

		        var days = Math.floor(distance / _day);
		        var hours = Math.floor((distance % _day) / _hour);
		        var minutes = Math.floor((distance % _hour) / _minute);
		        var seconds = Math.floor((distance % _minute) / _second);

		        // document.getElementById('countdown').innerHTML = days + 'days ';
		        // document.getElementById('countdown').innerHTML += hours + 'hrs ';
		        // document.getElementById('countdown').innerHTML += minutes + 'mins ';
		        // document.getElementById('countdown').innerHTML += seconds + 'secs';

		        daysEl.html(days);
				hoursEl.html(hours);
				minsEl.html(minutes);
				secsEl.html(seconds);

		        // console.log(days + 'days ' + hours + 'hrs ' + minutes + 'mins ' + seconds + 'secs');
		    }

		    timer = setInterval(showRemaining, 1000);

			// target.setHours(hours);
			// target.setMinutes(minutes);
			// target.setSeconds(seconds);
			// target.setMilliseconds(0); // make sure that miliseconds is 0
			// timerDiv.innerHTML = target.toTimeString().split(" ")[0];

			// var timerCountdown = function() {
			// 	setTimeout(function() {

			// 		timerCountdown();
			// 	}, 1000);
			// };
			// timerCountdown();
		}
	};

	var processStepContent = function() {
		$('[data-action="hotseat-process-step-content"]').on('click', function(e) {
			$(this).toggleClass('open');
		});
	};



	$(document).ready(function(){
		homeHeroSlider();
		heroVideo();
		scrollAnim();
		scrollToAnchor();
		blockGallery();
		testimonialsSlider();
		videoPlay();
		faq();
		tabs();
		tabSlider();
		downloadGate();
		paymentForm();
		resources();
		loginForm();
		ebookPopup();
		animateNumbers();
		countdownTimer();
		hotseatHero();
		hotseatTestimonialsSlider();
		processStepContent();
	});

    window.addEventListener('load', function() {
        var videoContainer = $('.hero-video-container');
        videoContainer.addClass('vis');
    }, false);

})(jQuery);

/* Lazy load bg images https://web.dev/lazy-loading-images/ */
// document.addEventListener("DOMContentLoaded", function() {
//   var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

//   if ("IntersectionObserver" in window) {
//     let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
//       entries.forEach(function(entry) {
//         if (entry.isIntersecting) {
//           entry.target.classList.add("visible");
//           lazyBackgroundObserver.unobserve(entry.target);
//         }
//       });
//     });

//     lazyBackgrounds.forEach(function(lazyBackground) {
//       lazyBackgroundObserver.observe(lazyBackground);
//     });
//   }
// });